module.exports = __webpack_public_path__ + "19b4c1dc4664aa3f00e7194831b44dc4.svg";